/**
 * API de triaje del paciente.
 */
import { apiFetch } from "./client";

export interface Triaje {
  id: number;
  cita_id: number | null;
  paciente_id: number;
  paciente_nombre: string;
  sede_id: number | null;
  sede_nombre: string | null;
  tomado_por_user_id: number | null;
  /** Quién tomó las funciones vitales. */
  tomado_por_nombre: string | null;
  fecha: string;

  motivo_consulta: string;
  nivel_urgencia: number;
  especialidad_sugerida_id: number | null;
  especialidad_sugerida_nombre: string | null;

  pa_sistolica: number | null;
  pa_diastolica: number | null;
  fc: number | null;
  fr: number | null;
  temperatura: string | number | null;
  sat_o2: number | null;
  peso: string | number | null;
  /** En cm. Numeric en la base, así que puede llegar como string. */
  talla: string | number | null;

  observaciones: string | null;
  created_at: string;
}

export interface TriajeCreate {
  paciente_id: number;
  /** Atención a la que pertenece. */
  cita_id?: number | null;
  sede_id?: number | null;
  motivo_consulta: string;
  nivel_urgencia: number;
  especialidad_sugerida_id?: number | null;
  pa_sistolica?: number | null;
  pa_diastolica?: number | null;
  fc?: number | null;
  fr?: number | null;
  temperatura?: number | null;
  sat_o2?: number | null;
  peso?: number | null;
  talla?: number | null;
  observaciones?: string | null;
}

export function listTriajesDePaciente(
  pacienteId: number,
): Promise<Triaje[]> {
  return apiFetch<Triaje[]>(`/v1/pacientes/${pacienteId}/triajes`);
}

export function createTriaje(payload: TriajeCreate): Promise<Triaje> {
  return apiFetch<Triaje>("/v1/triajes", {
    method: "POST",
    body: payload,
  });
}

export function getTriaje(id: number): Promise<Triaje> {
  return apiFetch<Triaje>(`/v1/triajes/${id}`);
}
